import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
export default function removeSignalListenersFromView(view, signalListeners) {
  var signalNames = _Object$keys(signalListeners);

  _forEachInstanceProperty(signalNames).call(signalNames, function (signalName) {
    try {
      view.removeSignalListener(signalName, signalListeners[signalName]);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Cannot remove invalid signal listener.', error);
    }
  });

  return signalNames.length > 0;
}